import { getDefaultAddress } from '../redux-api-bridge/selectors'

export const getCountry = state => {
  try {
    const defaultAddress = getDefaultAddress(state)
    return defaultAddress?.country?.toUpperCase() || undefined
  } catch (err) {
    console.error(`[getCountry] Error getting country: ${err}`)
    return undefined
  }
}
